import Vue from 'vue'
import urls from '../services.url.js'
import authHeaders from './headers'

export default {
  teamNavGuard (teamId) {
    let target = urls.NAV_GUARD_TEAM + teamId + '/'
    return Vue.http.get(target, {'headers': authHeaders.getAuthHeaders()})
  }
}



// WEBPACK FOOTER //
// ./src/api/real-api/navguard.api.js